import { useEffect } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';
import { tracking } from '@iwoca/frontend-tracking-library';
import { IconQuestionMarkFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import messages from './UnknownView.messages';
import styles from './UnknownView.module.css';
import * as IwDataDogLogger from '../../../iwLogger/IwDataDogLogger';
import { TProductType } from '../../../myAccount/dashboard/Dashboard.types';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper/index';

type TUnkownView = {
    accountId: string;
    productType: Exclude<TProductType, undefined | null>;
    accountStatus: string;
};

const UnknownView = ({
    accountId,
    productType,
    accountStatus
}: TUnkownView) => {
    useEffect(() => {
        tracking.ampli.dashboardViewed({
            account_id: accountId,
            // @ts-expect-error Ampli type doesn't have term_loan. Needs adding
            product_type: productType,
            dashboard_state: 'unknown'
        });
    }, [accountId, productType]);

    useEffect(() => {
        IwDataDogLogger.logError(
            `Unknown view visited- Account Status is ${accountStatus}`,
            {
                tags: {
                    reporter: 'Unknown View'
                }
            }
        );
    }, [accountStatus]);

    return (
        <MainSectionWrapper>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconQuestionMarkFilled className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage
                        {...messages.description}
                        values={{
                            phoneNumber: (
                                <a
                                    href={
                                        getCountry() === 'DE'
                                            ? 'tel:069 9432 3020 '
                                            : 'tel:020 3778 0274'
                                    }
                                    className={styles.phoneNumber}
                                >
                                    <FormattedMessage
                                        tagName="strong"
                                        {...messages.phoneNumber}
                                    />
                                </a>
                            )
                        }}
                    />
                </div>
            </div>
        </MainSectionWrapper>
    );
};

// eslint-disable-next-line import/no-default-export
export default UnknownView;
